var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row items-center space-x-4 md:p-6 p-4 border-2 rounded-lg",class:{
        'border-r-red text-r-red': _vm.type === 'error',
        'border-r-green bg-r-green-5 text-r-green': _vm.type === 'success',
    }},[(_vm.icon)?_c('div',{staticClass:"text-xl"},[(_vm.icon !== null)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-base"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }